import React from "react";
import { Download, FileText } from "lucide-react";

const DOCUMENTS = [
  {
    title: "Auction Process",
    description: "How our auctions work, from registration to settlement.",
    file: "/documents/Auction-Process.pdf",
    name: "Anachronistic-Auction-House-Auction-Process.pdf",
  },
  {
    title: "Custody Agreement for Secured Funds Transfer",
    description: "Terms governing the custody and secure transfer of funds.",
    file: "/documents/Custody-Agreement-for-Secured-Funds-Transfer.pdf",
    name: "Custody-Agreement-for-Secured-Funds-Transfer.pdf",
  },
];

const AuctionDocuments = () => (
  <section className="aah-docs" aria-label="Auction documents">
    <div className="eyebrow">Documents</div>
    <ul>
      {DOCUMENTS.map((doc) => (
        <li key={doc.file}>
          <FileText aria-hidden="true" />
          <div>
            <strong>{doc.title}</strong>
            <span>{doc.description}</span>
          </div>
          <a href={doc.file} download={doc.name}>
            <Download aria-hidden="true" />
            Download PDF
          </a>
        </li>
      ))}
    </ul>
  </section>
);

export default AuctionDocuments;
